import { useTranslation } from "react-i18next";
import { PageContainer } from "@/components/core/PageContainer";
import { GenerateReportForm } from "@/components/blocks/GenerateReport/GenerateReportForm";
import { Title } from "@/components/core/Title";
import { useDisableLocationSelection } from "@/hooks/useDisableLocationSelection";

export function GenerateReport() {
  const { t } = useTranslation();
  
  // Disable location selection on this page
  useDisableLocationSelection(true);

  return (
    <PageContainer className="flex flex-col">
      <Title>{t("generateReport.title")}</Title>

      <GenerateReportForm />
    </PageContainer>
  );
} 